import React from 'react';
import { AlertCircleIcon, RefreshCwIcon } from 'lucide-react';

interface WhatsAppSyncRecoveryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onResume: () => void;
}

export function WhatsAppSyncRecoveryModal({
  isOpen,
  onClose,
  onResume,
}: WhatsAppSyncRecoveryModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-md p-6">
        <div className="flex items-center gap-3 mb-4">
          <AlertCircleIcon className="w-8 h-8 text-amber-500" />
          <h2 className="text-lg font-semibold text-gray-900">
            WhatsApp Sync Interrupted
          </h2>
        </div>

        <p className="text-sm text-gray-600 mb-6">
          Your WhatsApp message sync was interrupted. Would you like to resume syncing your messages?
        </p>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors"
          >
            Skip for now
          </button>
          <button
            onClick={onResume}
            className="flex-1 px-4 py-3 bg-[#5B8E87] text-white rounded-xl font-medium hover:bg-[#4F7A74] transition-colors flex items-center justify-center gap-2"
          >
            <RefreshCwIcon className="w-4 h-4" />
            Resume Sync
          </button>
        </div>
      </div>
    </div>
  );
}
